var map = {
	"./Green-VeryLow.png": 968,
	"./Green-VeryLow.svg": 2410,
	"./Red-Excessive.png": 964,
	"./Red-Excessive.svg": 2411,
	"./RedYellow-Significant.png": 965,
	"./RedYellow-Significant.svg": 2412,
	"./White-Unknown.png": 584,
	"./White-Unknown.svg": 2413,
	"./Yellow-Moderate.png": 966,
	"./Yellow-Moderate.svg": 2414,
	"./YellowGreen-Low.png": 967,
	"./YellowGreen-Low.svg": 2415
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2409;


//////////////////
// WEBPACK FOOTER
// ./static/images/delay-map ^\.\/.*$
// module id = 2409
// module chunks = 1